module.exports = {"451031100":"新州镇","451031101":"桠杈镇","451031102":"天生桥镇","451031103":"平班镇","451031104":"德峨镇","451031105":"隆或镇","451031200":"沙梨乡","451031203":"者保乡","451031204":"者浪乡","451031205":"革步乡","451031206":"金钟山乡","451031208":"猪场乡","451031210":"蛇场乡","451031211":"克长乡","451031213":"岩茶乡","451031215":"介廷乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451031.json
// module id = 2151
// module chunks = 0